import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const UpdateContent = lazy(() => import('./UpdateContent'));
const UpdateSettings = lazy(() => import('./UpdateSettings'));

export function PageRoutes() {
  return (
    <Routes>
      <Route path={Pages.cms.page.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.cms.page.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.cms.page.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.cms.page.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.cms.page.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.cms.page.update.meta.path}
          element={(<UpdateContent />)}
        />
        <Route
          path={Pages.cms.page.updateSettings.meta.path}
          element={(<UpdateSettings />)}
        />
      </Route>
    </Routes>
  );
}
